export default __webpack_public_path__ + "static/accountantsVp5-efee7b9c71f13ef53c0d0c50b33bff65.png";